import { SNoop } from '@obvious.tech/util/validation/schemas'
import { defineEntity } from '../../defineEntity'
import { IScenario } from '@obvious.tech/constellation'

export const Scenario = defineEntity('Scenario', {
  endpoint: 'simulator/api/Scenario',
  schema: SNoop<IScenario>(),
})
